const commentItems = [
  {
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20boy%20avatar%20portrait%20with%20warm%20peach%20background%2C%20simple%20flat%20illustration%2C%20friendly%20expression%2C%20clean%20minimal%20design%2C%20circular%20crop%20ready&width=120&height=120&seq=avatar-wang&orientation=squarish',
    text: '用了51漫画在线观看两年了，资源真的很全！下拉式阅读体验太爽了，追更完全停不下来。推荐给所有漫画爱好者。',
    date: '3天前',
  },
  {
    name: '追更达人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20portrait%20with%20warm%20coral%20background%2C%20simple%20flat%20illustration%2C%20happy%20expression%2C%20clean%20minimal%20design%2C%20circular%20crop%20ready&width=120&height=120&seq=avatar-daren&orientation=squarish',
    text: '每天刷新等更新已经成习惯了！51漫画在线的实时更新功能真的很赞，热门漫画更新速度一流，比很多平台都快。',
    date: '5天前',
  },
  {
    name: '二次元老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20male%20avatar%20portrait%20with%20warm%20amber%20background%2C%20simple%20flat%20illustration%2C%20confident%20expression%2C%20clean%20minimal%20design%2C%20circular%20crop%20ready&width=120&height=120&seq=avatar-laosiji&orientation=squarish',
    text: '免费漫画在线阅读真的太良心了！手机上用浏览器直接看，不用下载任何APP，流畅度完全不输客户端，强烈安利。',
    date: '1周前',
  },
  {
    name: '国漫支持者',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20portrait%20with%20warm%20pink%20background%2C%20simple%20flat%20illustration%2C%20gentle%20expression%2C%20clean%20minimal%20design%2C%20circular%20crop%20ready&width=120&height=120&seq=avatar-guoman&orientation=squarish',
    text: '国漫崛起！51漫画在线上国漫资源真的很多，从斗破到镖人，从一人之下到镇魂街，质量越来越高，支持国产漫画！',
    date: '2周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">读者评价</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">来自51漫画在线读者的真实反馈与推荐</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {commentItems.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-2xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">{item.name}</h3>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.text}</p>
              <div className="flex items-center gap-1 mt-3 text-accent-500">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}